



















































import { Vue, Component, Prop } from "vue-property-decorator";
import moment from "moment";
import { lockModule } from "@/store/lock";
import {
  Lock,
  GetLockLogsResult,
  DeviceLogTypeMask
} from "@/../generated/iloq-api";
import LockLogListEntry from "@/components/LockLogListEntry.vue";

@Component({
  components: { LockLogListEntry }
})
export default class LockListItem extends Vue {
  @Prop(Object) lock!: Lock;
  currentLog: GetLockLogsResult | null = null;
  showLog = false;
  loading = false;
  masks = [
    { mask: DeviceLogTypeMask.NUMBER_0, value: "Unknown type" },
    { mask: DeviceLogTypeMask.NUMBER_1, value: "Failed access" },
    { mask: DeviceLogTypeMask.NUMBER_2, value: "Lock was programmed" },
    { mask: DeviceLogTypeMask.NUMBER_4, value: "Successful access" },
    { mask: DeviceLogTypeMask.NUMBER_8, value: "Phone accessed the lock" },
    { mask: DeviceLogTypeMask.NUMBER_16, value: "Fob accessed the lock" },
    { mask: DeviceLogTypeMask.NUMBER_1024, value: "Key accessed the lock" },
    {
      mask: DeviceLogTypeMask.NUMBER_2048,
      value: "5 Series key accessed the lock"
    },
    {
      mask: DeviceLogTypeMask.NUMBER_4096,
      value: "Unknown key (Key is empty or in factory state)"
    },
    { mask: DeviceLogTypeMask.NUMBER_8192, value: "Snap open access" },
    {
      mask: DeviceLogTypeMask.NUMBER_16384,
      value: "Log is a key passage from a lock which doesn't collect logs."
    }
  ];

  get logEntries() {
    return (
      this.currentLog?.LockLogs?.sort((a, b) => {
        return moment(b.GoingDateUtc).diff(moment(a.GoingDateUtc));
      }) ?? []
    );
  }

  toggleLog() {
    this.showLog = !this.showLog;
    if (this.showLog) {
      this.fetchLockLog();
    }
  }

  fetchLockLog() {
    if (this.lock.FLock_ID) {
      this.loading = true;
      lockModule
        .fetchLockLog(this.lock.FLock_ID)
        .then(response => {
          this.currentLog = response;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
